import entity from '../../../models/mlm/commissions'

export default [
  {
    path: '/commissions',
    meta: {
      entity,
      requiresPermissionTo: 'commissions',
      crud: 'list'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  },
  {
    path: '/commissions/new',
    meta: {
      entity,
      requiresPermissionTo: 'commissions',
      crud: 'form'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  },
  {
    path: '/commissions/:id',
    meta: {
      entity,
      requiresPermissionTo: 'commissions',
      crud: 'form'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  }
]
